import React from 'react';

import { EventPublicInfoPlace } from 'src/types/dto';

import './PlaceCard.scss';
import { Box, Icon } from '@chakra-ui/react';
import { FaExternalLinkAlt } from 'react-icons/fa';

const PlaceCard: React.FC<{
  place?: EventPublicInfoPlace;
}> = ({ place }) => {
  if (!place) {
    return null;
  }

  return (
    <Box
      display="grid"
      gridTemplateColumns="1fr"
      gap="5"
      p={{ base: 1, md: 4 }}
      bgColor="white"
      position={{ base: 'relative', md: 'absolute' }}
      boxShadow={{ base: 'none', md: '0 6px 28px 0 #1834754d' }}
      left={{ base: 0, md: '5' }}
      top={{ base: 0, md: '12.5%' }}
      borderRadius="10px"
      w={{ base: 'full', md: '350px' }}
      transform="none"
      mt={{ base: '5', md: '0' }}
      className="event-place-card">
      <div className="info">
        <span className="place-name">{place.name}</span>
        <span className="place-address">{place.address}</span>
        <div className="place-divide">
          <div>
            <a
              href={
                place.position &&
                'https://www.google.com/maps/search/?api=1&query=' +
                  place.position.lat +
                  ',' +
                  place.position.lng
              }
              target="_blank"
              rel="noopener noreferrer">
              <Icon as={FaExternalLinkAlt} /> Ver mapa
            </a>
          </div>
          <div></div>
        </div>
      </div>
    </Box>
  );
};

export default PlaceCard;
